<mat-expansion-panel *ngFor="let entry of transformerEntries; index as idx" hideToggle class="gridConnection-panel-header">

  <mat-expansion-panel-header>
    <mat-panel-title>
      <div>Manufacturer: {{entry.fg.value.manufacturer}}</div>
      <div>MVA Rating: {{entry.fg.value.mvaRating}}</div>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <digires-text-input [textarea]="true"
                      [formGroup]="entry.fg"
                      formCtrlName="manufacturer"
                      placeholder="Manufacturer of Transformer in the Main On Site Substation"
                      tooltip="The name of the manufacturer of this transformer in the main on site substation."
  ></digires-text-input>

  <digires-text-input [textarea]="true"
                      [formGroup]="entry.fg"
                      formCtrlName="mvaRating"
                      placeholder="MVA Rating of Transformer in the Main On site Substation"
                      tooltip="The MVA (Megavolt-Amperes) rating of this Transformer in the Main On Site Substation
                      identifying the amount of apparent power that the transformer can handle. The rating can be
                      expressed with and without any additional cooling (e.g. 50/63MVA ONAN/ONAF)."
  ></digires-text-input>

  <digires-button *ngIf="idx > 0" icon="delete" [disabled]="disabled" (onClick)="onRemoveEntry(entry)"></digires-button>
</mat-expansion-panel>

<digires-button icon="add" [disabled]="disabled" (onClick)="onAddEntry()"></digires-button>
